module.exports = __webpack_public_path__ + "static/media/automatic.b3026bcc.svg";